import PropTypes from 'prop-types';
import React from 'react';

import {PARTNER_MACHINES} from '../../../constants/partnerMachines';
import LazyImage from '../LazyImage';
import './PartnerMachinesGrid.style.scss';

export const PartnerMachinesGrid = React.memo((props) => {
  const {className, excludeIds = [], centerLastRow = false} = props;

  const filteredMachines = PARTNER_MACHINES.filter(
    (machine) => !excludeIds.includes(machine.id)
  );

  const gridClassName = `partner-machines-grid ${className || ''} ${centerLastRow ? 'partner-machines-grid--center-last' : ''}`;

  return (
    <div className={gridClassName}>
      {filteredMachines.map((machine) => (
        <div className="partner-machines-grid__item" key={machine.id}>
          <LazyImage id={machine.id} src={machine.image} alt={machine.name} />
        </div>
      ))}
    </div>
  );
});

PartnerMachinesGrid.propTypes = {
  className: PropTypes.string,
  excludeIds: PropTypes.arrayOf(PropTypes.string),
  centerLastRow: PropTypes.bool
};
